import React, {forwardRef} from 'react'
import {Input} from 'reactstrap'
import {ReactComponent as IconSearch} from '../../../../assets/icons/search.svg'
import {ModalShapesContent} from './ModalShapesContent'
import useDebounce from '../../../../hooks/useDebounce'
import {TYPE_FILTERS} from '../../../../constant/shapes'
import clsx from '../../../../helpers/clsx'
import {useNavigate, useParams} from 'react-router-dom'
import ConditionalRender from '../../../../shared/ConditionalRender'
import {hasFeatureTag} from '../../../../helpers/settings'

const ModalShapes = () => {
    const [typeFilter, setTypeFilter] = React.useState('all')
    const [nameFilter, setNameFilter] = React.useState('')
    const nameFilterDebounced = useDebounce(nameFilter)
    const navigate = useNavigate()
    const {productId} = useParams()

    /**
     * Handle search input change
     * @param {React.ChangeEvent<HTMLElement>} event - Event object
     */
    const handleCreateNewShape = (_event) => {
        navigate(`/create-custom-shape?callbackUrl=/${productId}`)
    }

    /**
     * Handle search input change
     * @param {React.ChangeEvent<HTMLInputElement>} event - Event object
     */
    const handleSearch = (event) => {
        setNameFilter(event.target.value)
    }

    return (
        <div className="ModalShapes">
            <h3 className="ModalShapesTitle">
                Shapes cut
                <ConditionalRender condition={hasFeatureTag('custom_shape_step2')} fallback={null}>
                    <span className="CreateNewShapeTrigger" onClick={handleCreateNewShape}>
                        Create a new shape
                    </span>
                </ConditionalRender>
            </h3>
            <InputSearch onChange={handleSearch} name="name" id="inputSearch" placeholder="Search shape..." />
            <ListFilter value={typeFilter} onChange={setTypeFilter} />
            <ModalShapesContent typeFilter={typeFilter} nameFilter={nameFilterDebounced} productId={productId} />
        </div>
    )
}

const InputSearch = forwardRef(({className, inputClassName, onChange, ...rest}, ref) => {
    return (
        <div className={clsx('InputSearch', className)}>
            <IconSearch />
            <Input onChange={onChange} ref={ref} className={clsx('InputSearchInput', inputClassName)} {...rest} />
        </div>
    )
})

const ListFilter = forwardRef(({className, value, onChange, ...rest}, ref) => {
    return (
        <div className={clsx('ListFilter', className)} ref={ref} {...rest}>
            {TYPE_FILTERS.map((item) => (
                <div
                    className={clsx('ListFilterItem', item.value === value && 'active')}
                    key={item.value}
                    onClick={() => onChange(item.value)}
                >
                    {item.label}
                </div>
            ))}
        </div>
    )
})

export default ModalShapes

